import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { languages } from './languages/languages';

export const resources = Object.entries(languages).reduce(
  (acc, [lang, translation]) => ({ ...acc, [lang]: { translation } }),
  {}
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      lookupLocalStorage: 'language'
    },
    debug: true,
    interpolation: {
      escapeValue: false
    },
    saveMissing: true,
    missingKeyHandler: (ng, ns, key, fallbackValue) => {
      //console.error(`Key not found ${key}, ${ng}, ${ns}, ${fallbackValue}`);
    },
    fallbackLng: ['en', 'es']
  });

export default i18n;
